<template>
  <div class="actions-bar h-full flex flex-col items-center justify-center gap-4">
    <el-tooltip
      v-for="item in handleList" :key="item.type"
      :content="item.tip"
      placement="right"
      :open-delay="300"
      :disabled="(item.type === 'up' && disabledUp) || (item.type === 'down' && disabledDown) || (item.type === 'delete' && disabledDelete)"
    >
      <div
        class="actions-bar__item w-[32px] h-[32px] rounded-full bg-white flex items-center justify-center hover:bg-textColor-7"
        :class="[{ 'disabled': (item.type === 'up' && disabledUp) || (item.type === 'down' && disabledDown) || (item.type === 'delete' && disabledDelete) }, item.type === 'delete' ? 'is-delete' : '']"
        @click.stop="item.handle"
      >
        <i class="text-black item-icon text-18" :class="item.icon" />
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import { scrollTo } from '~/utils/dom'
export default {
  components: {
  },
  props: {
    selectWidget: {
      type: Object,
      default() {
        return {}
      }
    },
    widgetList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      handleList: [
        {
          type: 'up',
          icon: 'el-icon-top',
          disabled: false,
          handle: this.handleUp,
          tip: '上移'
        },
        {
          type: 'down',
          icon: 'el-icon-bottom',
          disabled: false,
          handle: this.handleDown,
          tip: '下移'
        },
        {
          type: 'delete',
          icon: 'el-icon-delete',
          disabled: false,
          handle: this.handleDelete,
          tip: '删除'
        }
      ]
    }
  },
  computed: {
    disabledUp() {
      let result = false
      const { selectWidget, widgetList } = this
      const current = selectWidget?.id || null
      if (!current) {
        result = true
      } else {
        const index = widgetList.findIndex(item => item.id === current)
        const prev = widgetList[index - 1]
        const prevInfo = prev?.getMenuInfo() || {}
        const curInfo = selectWidget?.getMenuInfo() || {}
        result = prev === undefined || (prevInfo.isDefault && !prevInfo.draggable) || (curInfo.isDefault && !curInfo.draggable)
      }
      return result
    },
    disabledDown() {
      let result = false
      const { selectWidget, widgetList } = this
      const current = selectWidget?.id || null
      if (!current) {
        result = true
      } else {
        const index = widgetList.findIndex(item => item.id === current)
        const next = widgetList[index + 1]
        const nextInfo = next?.getMenuInfo() || {}
        const curInfo = selectWidget?.getMenuInfo() || {}
        result = next === undefined || (nextInfo.isDefault && !nextInfo.draggable) || (curInfo.isDefault && !curInfo.draggable)
      }
      return result
    },
    disabledDelete() {
      let result = false
      const { selectWidget } = this
      if (!selectWidget) {
        result = true
      } else {
        const curInfo = selectWidget?.getMenuInfo() || {}
        result = curInfo.isDefault
      }
      return result
    }
  },
  methods: {
    handleUp() {
      const { selectWidget, widgetList } = this
      const index = widgetList.findIndex(item => item.id === selectWidget.id)
      const prev = index - 1
      this.$emit('up', index, prev)
      this.scrollToView()
    },
    handleDown() {
      const { selectWidget, widgetList } = this
      const index = widgetList.findIndex(item => item.id === selectWidget.id)
      const next = index + 1
      this.$emit('down', index, next)
      this.scrollToView()
    },
    scrollToView() {
      this.$nextTick(() => {
        const item = this.selectWidget
        if (item.id) {
          scrollTo(`${item.id}`, '.edit-content__center--wrapper')
        }
      })
    },
    handleDelete() {
      this.SiteMenu.openDeleteBlockDialog()
    }
  }
}
</script>

<style lang="less">
.actions-bar {
  padding: 0 5px;
  &__item {
    cursor: pointer;
    transition: transform .15s ease, box-shadow .15s ease, background-color .15s ease, opacity .2s ease;
    // 统一、柔化基础阴影（中性黑，避免主题色染色）
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(0, 0, 0, 0.08);

    .item-icon {
      transition: color .15s ease, opacity .2s ease, transform .15s ease;
    }

    &:hover {
      transform: translateY(-1px);
      // 统一 hover 阴影强度，避免过强
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
      .item-icon {
        color: @primary-1;
      }
    }

    &:active {
      transform: translateY(0);
      // active 阴影稍收敛
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
      .item-icon {
        transform: scale(0.98);
      }
    }

    &:focus-visible {
      outline: none;
      // 焦点环与基础阴影同时存在
      box-shadow: 0 0 0 3px fade(@primary-1, 30%), 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      box-shadow: none;
      border-color: rgba(0, 0, 0, 0.06);
      .item-icon {
        opacity: 0.2;
      }
    }

    // 删除按钮使用危险色 hover
    &.is-delete:hover {
      background-color: lighten(@error-color, 42%) !important;
      border-color: fade(@error-color, 30%);
      // 覆盖通用 hover 阴影，避免叠加异常
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
      .item-icon {
        color: @error-color;
      }
    }
  }
}
</style>
